import React from "react";
import { FaSearch, FaRedo } from "react-icons/fa";
import { termOptions } from "../../utils/helper";
import Select from "../../components/Select/Select";
import Button from "../../components/Button/Button";
import ExamHeaderSelect from "../ExamConfiguration/ExamHeaderSelect";
import MultiSelect from "../../components/Select/MultiSelect";

const AssessmentFilter = (props) => {
  return (
    <React.Fragment>
      <div className="row">
        <div className="col-md-4">
          <label className="form-label mt-1">Select Class</label>
          <MultiSelect
            options={props.programData && props.programData} // Options to display in the dropdown
            onChangeHandler={props.onProgramSelect} // Function will trigger on select/remove event
            selectedValues={props.programs}
            closeOnSelect={false}
            placeholder={"Select Class"}
            displayValue="name" // Property name to display in the dropdown options
          />
        </div>
        <div className="col-md-4">
          <Select
            label={"Subject"}
            name={"subject_id"}
            value={props.subject_id}
            placeholder={"Select Subject"}
            onChangeHandler={props.onChangeHandler}
            options={props.subjectData}
          />
        </div>
        <div className="col-md-4">
          <ExamHeaderSelect
            label="Exam Headers"
            name="name"
            placeholder={"Select Exam Headers"}
            value={props.name}
            onChangeHandler={props.onChangeHandler}
            examList={props.examList}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-4">
          <Select
            label="Evaluation"
            name="evaluation_type_id"
            placeholder={"Select Evaluation Type"}
            value={props.evaluation_type_id}
            onChangeHandler={props.onChangeHandler}
            options={props.evaluationType}
          />
        </div>
        <div className="col-md-4">
          <Select
            label="Term"
            name="term"
            placeholder={"Select Term"}
            value={props.term}
            onChangeHandler={props.onChangeHandler}
            options={termOptions}
          />
        </div>
        <div className="col-md-4">
          <label className="mb-1 mt-1 d-block invisible">Action</label>
          <div className="filter-actions">
            <Button
              variant="primary"
              type="submit"
              className="flex-fill"
              icon={<FaSearch />}
              onClick={() => props.handleSearch({ selected: 0 })}
            >
              Search
            </Button>
            <Button
              variant="secondary"
              className="flex-fill"
              icon={<FaRedo />}
              onClick={(event) => props.handleReset(event)}
            >
              Reset
            </Button>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default AssessmentFilter;
